module.exports = __webpack_public_path__ + "img/floor_f13_02.043871aa.png";